export default menuMobile => {
    // console.log('menuMobile');
    const ww = window.innerWidth;
    const menuItemsOpenSubmenu = document.querySelectorAll('.js-openSubmenu');
    const menuItemsBack = menuMobile.querySelectorAll('.js-goback');

    function openSubMenu(event) {
        event.preventDefault();

        if (event.target.closest('.parent-submenu') && event.target.closest('.parent-submenu').closest('.menu-item').querySelector('.sub-menu')) {
            event.target.closest('.parent-submenu').closest('.menu-item').querySelector('.sub-menu').classList.add('open');
        } else if (event.target.closest('.with-submenu') && event.target.closest('.with-submenu').querySelector('.sub-menu')) {
            event.target.closest('.with-submenu').querySelector('.sub-menu').classList.add('open');
        }
    }

    function closeSubMenu(event) {
        event.preventDefault();
        console.log('close');
        if (event.target.closest('.sub-menu')) {
            event.target.closest('.sub-menu').classList.remove('open');
        }
        return false;
    }

    if (ww < 992) {
        for (const menuItemLink of menuItemsOpenSubmenu) {
            if ((menuItemLink.closest('.with-submenu') && menuItemLink.closest('.menu-item') && menuItemLink.closest('.menu-item').classList.contains('with-submenu') && menuItemLink.closest('.with-submenu').querySelector('.sub-menu') !== null) || (menuItemLink.closest('.parent-submenu') && menuItemLink.closest('.parent-submenu').closest('.menu-item').querySelector('.sub-menu') !== null)) {
                menuItemLink.closest('.menu-item-link').addEventListener('click', openSubMenu);
            }
        }

        for (const menuItemBack of menuItemsBack) {
            menuItemBack.addEventListener('click', closeSubMenu);
        }

        let itemmenus = document.querySelectorAll('.menu-item');
        for (const itemmenu of itemmenus) {
            if (!itemmenu.classList.contains('with-submenu')) {
                itemmenu.addEventListener('click', function (e) {
                    var target = e.target;
                    if (!target.classList.contains('js-goback')) {
                        if (itemmenu.querySelectorAll('.menu-item-link a').length > 0) {
                            itemmenu.querySelector('.menu-item-link a').click();
                        }
                    }
                });
            }
        }



    }

    let menu_items = document.querySelectorAll('.menu-action li');
    for (let i = 0; i < menu_items.length; i++) {
        let menu_item = menu_items[i];
        let menu_name = menu_item.getAttribute('data-name');
        if (document.querySelectorAll('.item-submenu.menu-' + menu_name).length > 0) {
            let submenu = document.querySelector('.item-submenu.menu-' + menu_name);
            menu_item.querySelector('a').addEventListener('click', function (e) {
                e.preventDefault();

                if (document.querySelectorAll('#menu-mobile-btn.open').length > 0) {
                    document.querySelector('#menu-mobile-btn.open').click();
                }

                let alreadyclass = submenu.classList.contains('open');
                document.querySelectorAll('.item-submenu').forEach(el => {
                    el.classList.remove('open');
                });
                if (alreadyclass === false) {
                    submenu.classList.add('open');
                }
                return false;
            });


            let contents = submenu.querySelectorAll('.content-submenu');
            for (let j = 0; j < contents.length; j++) {
                let content = contents[j];
                let title = content.querySelector('.sub-title');
                if (content.querySelectorAll('.subsubmenus').length > 0) {
                    let subsubmenus = content.querySelector('.subsubmenus');
                    title.addEventListener('click', function (e) {
                        e.preventDefault();
                        let alreadysubmenuclass = content.classList.contains('open');
                        let delay = 0;
                        /*if (submenu.querySelectorAll('.content-submenu.open').length > 0) {
                            submenu.querySelectorAll('.content-submenu').forEach(el => {
                                el.classList.remove('open');
                            });
                            delay = 0.35;
                        }*/
                        if (alreadysubmenuclass === false) {
                            setTimeout(function () {
                                content.classList.add('open');
                            }, delay);
                        } else {
                            content.classList.remove('open');
                        }
                        return false;
                    });


                    let itemsubsubmenus = subsubmenus.querySelectorAll('.item-subsubmenu');
                    for (let k = 0; k < itemsubsubmenus.length; k++) {
                        let itemsubsubmenu = itemsubsubmenus[k];
                        if (content.querySelectorAll('.list-subsubmenus').length > 0) {
                            let subtitle = itemsubsubmenu.querySelector('.title-subsubmenu');
                            let subsubsubmenus = itemsubsubmenu.querySelector('.list-subsubmenus');
                            subtitle.addEventListener('click', function (e) {
                                e.preventDefault();
                                console.log(itemsubsubmenu);
                                let alreadysubsubmenuclass = itemsubsubmenu.classList.contains('open');
                                let delay = 0;
                                /*if (submenu.querySelectorAll('.content-submenu.open').length > 0) {
                                    submenu.querySelectorAll('.content-submenu').forEach(el => {
                                        el.classList.remove('open');
                                    });
                                    delay = 0.35;
                                }*/
                                if (alreadysubsubmenuclass === false) {
                                    setTimeout(function () {
                                        itemsubsubmenu.classList.add('open');
                                    }, delay);
                                } else {
                                    itemsubsubmenu.classList.remove('open');
                                }
                                return false;
                            });
                        }
                    }





                }
            }
        }
    }


};
